import { h, defineComponent } from 'vue';
import { Icon } from '@/ui/components/icon/Icon';
import { t } from '@/ui/i18n/i18n';

export const SecurePayment = defineComponent({
  setup() {
    return function render() {
      return h('div', { class: 'subscribe_page__secure-payment' }, [
        h(Icon, { props: { icon: 'lock', iconPack: 'far' } }),
        h('div', t('subscription.secure-payment')),
      ]);
    };
  },
});
